import React from 'react';
import { SHADCN, R, TYPO, S } from '../theme';
import { ChevronDown } from 'lucide-react';

export default function Collapse({ title, children, open, onToggle }) {
  return (
    <div style={{
      border: `1px solid ${SHADCN.border}`,
      borderRadius: R.md,
      marginBottom: S[4],
      background: SHADCN.card,
      overflow: 'hidden',
    }}>
      <button
        onClick={onToggle}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: `14px ${S[5]}px`,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          borderBottom: open ? `1px solid ${SHADCN.border}` : 'none',
          fontFamily: SHADCN.font,
        }}
      >
        <span style={{ ...TYPO.body, fontWeight: 600, color: SHADCN.fg }}>{title}</span>
        <ChevronDown
          size={18}
          color={SHADCN.mutedFg}
          style={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: `transform ${SHADCN.durSlow} ${SHADCN.easeOut}`,
            flexShrink: 0,
          }}
        />
      </button>
      {/* grid-template-rows 0fr → 1fr : slide-down animé sans mesurer la hauteur */}
      <div style={{
        display: 'grid',
        gridTemplateRows: open ? '1fr' : '0fr',
        transition: `grid-template-rows ${SHADCN.durSlow} ${SHADCN.easeOut}`,
      }}>
        <div style={{ overflow: 'hidden' }}>
          <div style={{ padding: S[5], color: SHADCN.fg }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
